import { useTranslation } from "react-i18next";

const APP_STORE_URL =
  "https://apps.apple.com/app/gymkee-coaching-sportif/id1562498557";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.gymkee";

function Checkoutv1Success() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 px-6">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
        <svg
          className="h-10 w-10 text-green-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      <h1 className="text-center font-[Poppins] text-3xl font-semibold text-gray-900">
        {t("checkoutv1.success.title")}
      </h1>

      <p className="max-w-md text-center font-[Poppins] text-lg font-medium text-gray-600">
        {t("checkoutv1.success.text")}
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
            alt="Download on the App Store"
            className="h-[52px]"
          />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            alt="Get it on Google Play"
            className="h-[75px]"
          />
        </a>
      </div>
    </div>
  );
}

export { Checkoutv1Success };
